import { useState, useEffect, useRef } from 'react';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function useIsMounted() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setIsMounted = _useState2[1];

  useEffect(function () {
    setIsMounted(true);
  }, []);
  return isMounted;
}
/**
 * Lazy load 3rd party script AFTER the page has fully loaded.
 * This lazy script loader is indempotent. The first load
 * per unique script URL is cached, all subsequent calls for the
 * same script URL will be ignored.
 *
 * Example usage inside of functional React component:
 *   const scriptUrl = 'https://static.custom-script.js';
 *   const onLoad = () => { ... initialization code if necessary ... };
 *   const onError = () => { bugsnagError(new Error('custom-script failed to load')); };
 *   useLazyLoad({ scriptUrl, onLoad, onError });
 *
 * Note: this hook does not run for server side rendering.
 */
// Used to ensure we only lazy load a script once per session.


var scriptCache = {}; // Our custom hook which can be used to give lazy script loading
// capabilities to functional React components.

function useLazyLoadScript(_ref) {
  var _ref$scriptUrl = _ref.scriptUrl,
      scriptUrl = _ref$scriptUrl === void 0 ? '' : _ref$scriptUrl,
      _ref$onLoad = _ref.onLoad,
      onLoad = _ref$onLoad === void 0 ? function () {} : _ref$onLoad,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {} : _ref$onError,
      _ref$scriptLoader = _ref.scriptLoader,
      scriptLoader = _ref$scriptLoader === void 0 ? loadScript : _ref$scriptLoader;
  useEffect(function () {
    // If we have already attempted to load the script this session,
    // then there is nothing to do.
    if (scriptCache[scriptUrl]) {
      return;
    } // Cache the script URL.


    scriptCache[scriptUrl] = true; // This is our document complete event handler.

    var onReadyStateChange = function onReadyStateChange(event) {
      if (event.target.readyState === 'complete') {
        document.removeEventListener('readystatechange', onReadyStateChange);
        scriptLoader(scriptUrl, onLoad, onError);
      }
    }; // We use the readyState API to determine document load state.
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState


    if (document.readyState === 'complete') {
      scriptLoader(scriptUrl, onLoad, onError);
    } else {
      document.addEventListener('readystatechange', onReadyStateChange);
    }
  }, []
  /* ensures effect is run only once when component mounts */
  );
}
/**
 * This function handles loading the script.
 * It will be called right away if the document has finished loading.
 * Otherwise it will be called in a handler that fires when the document has finished laoding.
 */


function loadScript(scriptUrl, onLoad, onError) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = scriptUrl;

  script.onload = function () {
    onLoad();
  };

  script.onerror = function () {
    onError();
  }; // Lazy loaded scripts injection policy: appended to end of body.
  // document.body: https://developer.mozilla.org/en-US/docs/Web/API/Document/body
  // appendChild: https://developer.mozilla.org/en-US/docs/Web/API/Node/appendChild


  document.body.appendChild(script);
}
/**
 * Hook that allows storing and retrieving previous state values.
 */


function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
}
/**
 * Custom hook that ensures the component is still mounted before making
 * React setState calls. Should be used when component calls setState
 * AFTER await'ing on an async call to resolve.
 */


function useSafeSetState(setState) {
  // Track mounted status of the component.
  // We use a ref here (and not state) because
  // ref updates do NOT trigger re-renders and
  // this flag does not impact the rendered UI.
  var mountedRef = useRef(false);
  useEffect(function () {
    mountedRef.current = true;
    return function () {
      return mountedRef.current = false;
    };
  }, []); // now we can safely update state AFTER ensuring the component is still mounted.

  var safeSetState = function safeSetState() {
    return mountedRef.current && setState.apply(void 0, arguments);
  };

  return safeSetState;
}

function useMachine(_ref) {
  var _ref$initial = _ref.initial,
      initialState = _ref$initial === void 0 ? '' : _ref$initial,
      _ref$context = _ref.context,
      initialContext = _ref$context === void 0 ? {} : _ref$context,
      _ref$onDone = _ref.onDone,
      onDone = _ref$onDone === void 0 ? function () {} : _ref$onDone,
      _ref$states = _ref.states,
      states = _ref$states === void 0 ? {} : _ref$states;
  /**
   * This is where we store the active state and associated context data.
   * React Components can be passed these values to perform stateful rendering.
   */

  var _useState = useState({
    active: initialState,
    context: initialContext
  }),
      _useState2 = _slicedToArray(_useState, 2),
      currentState = _useState2[0],
      setState = _useState2[1];

  var safeSetState = useSafeSetState(setState);
  /**
   * State transitions are triggered by sending events and are
   * defined in the states key of the machine config. Events can be
   * sent by external actors or by the machine internally.
   *
   * Transitions may include target state, guard condition, and actions.
   * The guard condition is checked first. The transition to the target state
   * is made and actions executed only if the guard condition evaluates to true.
   * Actions are run syncronously with the transition and MUST be pure functions
   * or fire-and-forget side effects. This ensures order of operations is maintained
   * and there are no race conditions when transitioning from one state to the next.
   */

  var send = function send(event) {
    var active = currentState.active,
        context = currentState.context; // Look up the defined transitions for this state/event pair.

    var transitions = states[active].on[event.type];

    if (!Array.isArray(transitions) || transitions.length === 0) {
      // Early exit if there is no defined transition for the state/event pair.
      return;
    } // Process the transitions in order. Take the first transition where guard
    // condition is either undefined or evalutes to true. Run any actions
    // assocated with the taken transition.


    var _iterator = _createForOfIteratorHelper(transitions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var transition = _step.value;
        var actions = transition.actions,
            cond = transition.cond,
            target = transition.target; // Determine whether or not we should take this transition
        // based on the evaulation of the guard condition.

        var takeTransition = typeof cond !== 'function' || cond(context, event);

        if (!takeTransition) {
          continue;
        } // Evalute actions.
        // If actions return objects, the entries are considered to be updated
        // context value(s) and we implement merge semantics into the current context.
        // If 2 or more actions update the same context property, the last action's update
        // is chosen.


        var mergeContext = {};

        if (Array.isArray(actions) && actions.length > 0) {
          var _iterator2 = _createForOfIteratorHelper(actions),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var action = _step2.value;
              mergeContext = _objectSpread2(_objectSpread2({}, mergeContext), action(context, event));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        var contextUpdated = Object.keys(mergeContext).length > 0; // Construct the next context.

        var nextContext = contextUpdated ? _objectSpread2(_objectSpread2({}, context), mergeContext) : context; // Determine the next state.
        // If no target state is defined, then we remain in the current active state.

        var nextActiveState = target || active;
        var activeStateUpdated = nextActiveState !== active; // Transition to the next state if something has changed.

        if (activeStateUpdated || contextUpdated) {
          var nextState = {
            active: nextActiveState,
            context: nextContext
          };
          safeSetState(nextState);
        } // stop when we take first transition


        return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  /**
   * Services are invoked upon entry into a new active state.
   */


  var prevActiveState = usePrevious(currentState.active);
  useEffect(function () {
    var invokeService = function invokeService() {
      var active = currentState.active,
          context = currentState.context; // Early exit if the active state has not changed.

      if (active === prevActiveState) {
        return;
      } // Look up the service to invoke for this state.


      var service = states[active].invoke;

      if (_typeof(service) !== 'object') {
        return; // Early exit if there is no service defined for this state.
      } // Invoke the service.


      service.src(context)(send);
    };

    invokeService();
  }, [currentState, send, prevActiveState]);
  /**
   * Check if we have entered the final state.
   * If so, fire the onDone callback.
   */

  var isFinalState = states[currentState.active].type === 'final';
  useEffect(function () {
    var active = currentState.active,
        context = currentState.context; // Early exit if the active state has not changed.

    if (active === prevActiveState) {
      return;
    } // Fire the onDone callback if we have entered the final state.


    if (isFinalState) {
      onDone(context);
    }
  }, [currentState, isFinalState, onDone, prevActiveState]);
  return {
    currentState: currentState,
    send: isFinalState ? function () {} // do not process any more events once we reach final state
    : send
  };
}

export { useIsMounted, useLazyLoadScript, useMachine, usePrevious, useSafeSetState };